import { FontFamily } from '@bynder-studio/render-core';
import { getElementsFonts } from 'packages/store/user/user.selectors';

export function getDefaultFontId(elementsFonts: ReturnType<typeof getElementsFonts>, fonts: FontFamily[]) {
    const elementsFontId = elementsFonts[0]?.font.fonts[0]?.id;
    const fontFamily = fonts.find((item) => item.id === elementsFontId) || fonts[0];
    const font = fontFamily.fonts.find((item) => item.id === fontFamily.id) || fontFamily.fonts[0];

    return font.id?.toString();
}
